import utilService from '../../services/UtilService';
import scorableItemNumberingService from '../../services/questionView/ScorableItemNumberingService';
import assessmentReader from '../../store/readHelpers/AssessmentReader';
import questionReader from '../../store/readHelpers/QuestionReader';
import scorableItemReader from '../../store/readHelpers/ScorableItemReader';

const sectionAnswerKeysSelector = {
    prepareItemAnswerKeys(item, index, question) {
        const answerKeys = assessmentReader.getCorrectResponse(item);
        if (!answerKeys) {
            return null;
        }

        const isMatching = questionReader.isMatchingQuestion(question) || questionReader.isGapMatchQuestion(question);
        const isMultiInteractionGapMatchQuestion = questionReader.isGapMatchQuestionWithMultipleInteractions(question);
        const isMultipleResponse = questionReader.isMultipleResponseQuestion(question);

        return {
            contentRevisionId: item.contentRevisionId,
            isMatchingQuestion: isMatching,
            isMultipleResponseQuestion: isMultipleResponse,
            isMultipleInteractionGapMatchQuestion: isMultiInteractionGapMatchQuestion,
            itemIndex: index,
            keys: answerKeys,
            orderNumber: item.orderNumber,
        };
    },

    selectSectionAnswerKeys({ questions }) {
        const sectionAnswerKeys = questions.map(question => (
            scorableItemReader.getScorableItemsInQuestion(question.contentRevisionId)
                .map((item, index) => this.prepareItemAnswerKeys(item, index, question))
                .filter(sectionKeys => !!sectionKeys)
        ));

        return utilService.flatArray(sectionAnswerKeys);
    },

    getFormattedSectionAnswerKeys(sectionAnswerKeys) {
        if (!sectionAnswerKeys?.length || !Array.isArray(sectionAnswerKeys)) return [];

        function formatOrderNumbers(orderNumbers) {
            orderNumbers.sort((a, b) => a - b);
            const formatted = [];
            let start = orderNumbers[0];
            let end = start;

            for (let i = 1; i < orderNumbers.length; i++) {
                if (orderNumbers[i] === end + 1) {
                    end = orderNumbers[i];
                } else {
                    formatted.push(start === end ? `${start}` : `${start}-${end}`);
                    start = orderNumbers[i];
                    end = start;
                }
            }

            formatted.push(start === end ? `${start}` : `${start}-${end}`);

            return formatted.join(', ');
        }

        const groupedAnswerKeys = sectionAnswerKeys.reduce((acc, curr) => {
            if (curr?.isMultipleResponseQuestion) {
                const currentAcc = acc.find(
                    el => (
                        utilService.isDeepEqual(el.keys, curr.keys) &&
                        el.isMultipleResponseQuestion === curr.isMultipleResponseQuestion
                    )
                );

                if (currentAcc) {
                    currentAcc.itemIndex += `-${curr.itemIndex}`;
                    if (!currentAcc.orderNumbers) currentAcc.orderNumbers = [currentAcc.orderNumber];
                    currentAcc.orderNumbers.push(curr.orderNumber ? curr.orderNumber : 0);
                } else {
                    acc.push({
                        ...curr,
                        itemIndex: `${curr.itemIndex}`,
                        orderNumbers: [curr.orderNumber ? curr.orderNumber : 0],
                    });
                }
            } else {
                acc.push(curr);
            }
            return acc;
        }, []);

        const transformedAnswerKeys = groupedAnswerKeys.map((item) => {
            if (item.isMultipleResponseQuestion) {
                return {
                    ...item,
                    orderNumber: formatOrderNumbers(item.orderNumbers),
                };
            }
            return item;
        });

        return transformedAnswerKeys;
    },

    selectProps({ section }) {
        return {
            sectionAnswerKeys: this.getFormattedSectionAnswerKeys(this.selectSectionAnswerKeys(section)),
            sectionTitle: scorableItemNumberingService.getSectionFormatNumber(section.id, section.customFields),
        };
    },
};

export default sectionAnswerKeysSelector;
